import(/* webpackMode: "eager", webpackExports: ["ConsentLink"] */ "/app/src/components/common/ConsentLink/ConsentLink.tsx");
